/* eslint-disable no-param-reassign */
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getOr } from 'lodash/fp';
import moment from 'moment';
import api from './api';

const name = 'ticket';
const emptyTicketPricingState = {
  data: [],
  total: 0,
  totalAmount: null,
};

const getTicketConfig = createAsyncThunk(
  'ticket/getTicketConfig',
  async (payload) => {
    const response = await api.getTicketConfig(payload);
    return response;
  }
);

const setTicketConfig = createAsyncThunk(
  'ticket/setTicketConfig',
  async (payload) => {
    const response = await api.setTicketConfig(payload);
    return response;
  }
);

const getTicketVenues = createAsyncThunk(
  'ticket/getTicketVenues',
  async (params) => {
    const response = await api.getTicketVenues(params);
    return response;
  }
);
const getTicketTypes = createAsyncThunk(
  'ticket/getTicketTypes',
  async (params) => {
    const response = await api.getTicketTypes(params);
    return response;
  }
);
const getTicketEvents = createAsyncThunk(
  'ticket/getTicketEvents',
  async (params) => {
    const response = await api.getTicketEvents(params);
    return response;
  }
);
const getEventInsights = createAsyncThunk(
  'ticket/getEventInsights',
  async (params) => api.getEventInsights(params)
);
const getTickets = createAsyncThunk('ticket/getTickets', async (params) => {
  const response = await api.getTickets(params);
  return response;
});
const getOrders = createAsyncThunk('ticket/getOrders', async (params) => {
  const response = await api.getOrders(params);
  return response;
});
const getOrderItems = createAsyncThunk(
  'ticket/getOrderItems',
  async (params) => {
    const response = await api.getOrderItems(params);
    return response;
  }
);
const downloadTicketsCSV = createAsyncThunk(
  'ticket/downloadTicketsCSV',
  async (params) => {
    const response = await api.getTickets(params);
    return response;
  }
);
const downloadOrdersCSV = createAsyncThunk(
  'ticket/downloadOrdersCSV',
  async () => {
    const response = await api.getOrders({ limit: 1000 });
    return response;
  }
);
const getTicketPricing = createAsyncThunk(
  'ticket/getTicketPricing',
  async (params) => {
    const response = await api.getTicketPricing(params);
    return response;
  }
);
const updateTicketPricingOrder = createAsyncThunk(
  'ticket/updateTicketPricingOrder',
  async (payload) => {
    const response = await api.updateTicketPricingOrder(payload);
    return response;
  }
);
const updateStatusTicketConfig = createAsyncThunk(
  'ticket/updateStatusTicketConfig',
  async (payload) => {
    const response = await api.updateStatusTicketConfig(payload.id, payload);
    return response;
  }
);

const setDefaultTicketConfig = createAsyncThunk(
  'ticket/setDefaultTicketConfig',
  async (id) => {
    const response = await api.setDefaultTicketConfig(id);
    return response;
  }
);

const resetTicketConfig = createAsyncThunk(
  'ticket/resetTicketConfig',
  async () => {
    return true;
  }
);

const getEventsDiscountsList = createAsyncThunk(
  'tickets/events-discount',
  async (payload) => {
    return api.getEventsDiscountsList(payload);
  }
);
const getEventMembershipPlanConfigList = createAsyncThunk(
  'tickets/getEventMembershipPlanConfigList',
  async (payload) => {
    return api.getEventMembershipPlanConfigList(payload);
  }
);

const setEventsDiscounts = createAsyncThunk(
  'tickets/event-discount',
  async (payload) => {
    return api.setEventsDiscounts(payload);
  }
);

const editEventsDiscounts = createAsyncThunk(
  'tickets/event-discount',
  async (payload) => {
    return api.editEventsDiscounts(payload);
  }
);

const deleteEventsDiscounts = createAsyncThunk(
  'tickets/delete-event-discount',
  async (id) => {
    return api.deleteEventsDiscounts(id);
  }
);

const createEventMembershipPlanConfigList = createAsyncThunk(
  'tickets/createEventMembershipPlanConfigList',
  async (payload) => {
    return api.createEventMembershipPlanConfigList(payload);
  }
);
const editEventMembershipPlanConfigList = createAsyncThunk(
  'tickets/editEventMembershipPlanConfigList',
  async (payload) => {
    return api.editEventMembershipPlanConfigList(payload);
  }
);
const deleteEventMembershipPlanConfigList = createAsyncThunk(
  'tickets/deleteEventMembershipPlanConfigList',
  async (payload) => {
    return api.deleteEventMembershipPlanConfigList(payload);
  }
);

const setTicketEvent = createAsyncThunk('tickets/events', async (payload) => {
  return api.postTicketEvent(payload);
});

const previewRepeatTicketEvents = createAsyncThunk(
  'tickets/events/repeat/preview',
  async (payload) => api.previewRepeatTicketEvents(payload)
);

const repeatTicketEvents = createAsyncThunk(
  'tickets/events/repeat',
  async (payload) => api.repeatTicketEvents(payload)
);

const setCurrentTicketEvent = createAsyncThunk(
  'tickets/events',
  async (payload) => {
    return payload;
  }
);

const editTicket = createAsyncThunk('tickets/editTicket', async (payload) => {
  return api.editTicket(payload.id, payload);
});
const deleteTicketEvent = createAsyncThunk(
  'tickets/deleteTicketEvent',
  async (id) => {
    return api.deleteTicketEvent(id);
  }
);

const resendEmail = createAsyncThunk('membership/resendEmail', async (data) => {
  const response = await api.resendEmail(data);
  return response;
});

const getItemsByTicketing = createAsyncThunk(
  'tickets/publish-events-name',
  async () => {
    return api.getItemsByTicketing();
  }
);

const bulkTicketStatus = createAsyncThunk(
  'tickets/bulk-ticket-status',
  async (data) => {
    return api.bulkTicketStatus(data);
  }
);

const bulkTicketAction = createAsyncThunk(
  'tickets/bulk-ticket-action',
  async (data) => api.bulkTicketAction(data)
);

const bulkEventAction = createAsyncThunk(
  'tickets/bulk-event-action',
  async (data) => api.bulkEventAction(data)
);

const sendCustomEmail = createAsyncThunk(
  'tickets/send-custom-email',
  async (data) => {
    return api.sendCustomEmailApi(data);
  }
);

const getSchema = createAsyncThunk('tickets/getSchema', async (data) => {
  return api.getSchemaApi(data);
});

const deleteTicketType = createAsyncThunk(
  'tickets/deleteTicketType',
  async (id) => {
    return api.deleteTicketType(id);
  }
);

const deleteTicketPricingOfferCoupon = createAsyncThunk(
  'tickets/deleteTicketPricingOfferCoupon',
  async (id) => {
    return api.deleteTicketPricingOfferCoupon(id);
  }
);

const issueTickets = createAsyncThunk('tickets/issue-tickets', async (data) => {
  return api.issueTicketsApi(data);
});

const calculateTicketCost = createAsyncThunk(
  'tickets/calculate',
  async (data) => api.calculateTicketCostApi(data)
);

const sellerCheckout = createAsyncThunk(
  'tickets/seller-checkout',
  async (data) => api.sellerCheckoutApi(data)
);

const getEventTickets = createAsyncThunk(
  'tickets/events-tickets',
  async (eventid) => {
    const response = await api.getEventTicketsApi({ eventid });
    return response;
  }
);

const getEventCheckInLogs = createAsyncThunk(
  'tickets/event-check-in-logs',
  async ({ eventId, ...params }) =>
    api.getEventCheckInLogs(
      eventId,
      Object.keys(params).reduce(
        (query, key) =>
          params[key] === null || params[key] === undefined
            ? query
            : { ...query, [key]: params[key] },
        {}
      )
    )
);

const getReportEventTickets = createAsyncThunk(
  'ticket/event-stats',
  async (payload) => {
    const response = await api.getReportEventTicketApi(payload);
    return response;
  }
);

const getTicketPricingView = createAsyncThunk(
  'ticket/getTicketPricingView',
  async (params) => {
    const response = await api.getTicketPricingViewApi(params);
    return response;
  }
);
const refundTicket = createAsyncThunk(
  'tickets/refund-ticket',
  async (params) => {
    const response = await api.refundTicketApi(params);
    return response;
  }
);

const { actions, reducer } = {
  ...createSlice({
    name,
    initialState: {
      isLoading: false,
      imgIsLoading: false,
      error: {},
      ticketConfig: {},
      event: {},
      configs: {
        data: [],
        total: 0,
      },
      venues: {
        data: [],
        total: 0,
      },
      ticketTypes: {
        data: [],
        total: 0,
      },
      events: {
        data: [],
        total: 0,
      },
      eventInsights: {
        summary: {},
        events: [],
      },
      discounts: [],
      membershipPlans: [],
      tickets: {
        data: [],
        total: 0,
      },
      pricing: {
        ...emptyTicketPricingState,
      },
      listTicketPricing: {
        ...emptyTicketPricingState,
      },
      getOrders: {
        data: [],
        total: 0,
      },
      csv: [],
      orderItems: [],
      listSchema: [],
      eventStats: [],
      eventCheckInLogs: {
        data: [],
        total: 0,
      },
    },
    reducers: {
      resetMembershipPlans: () => ({
        membershipPlans: [],
      }),
    },
    extraReducers: {
      [setTicketConfig.pending]: (state) => ({
        ...state,
        isLoading: true,
      }),
      [setTicketConfig.fulfilled]: (state, action) => ({
        ...state,
        isLoading: false,
        ticketConfig: getOr({}, ['payload'], action),
      }),
      [setTicketConfig.rejected]: (state, payload) => ({
        ...state,
        isLoading: false,
        error: payload,
      }),
      [getTicketConfig.pending]: (state) => ({
        ...state,
        isLoading: true,
      }),
      [getTicketConfig.fulfilled]: (state, action) => ({
        ...state,
        isLoading: false,
        ticketConfig: getOr({}, ['payload'], action),
      }),
      [resetTicketConfig.fulfilled]: (state) => ({
        ...state,
        isLoading: false,
        ticketConfig: {},
      }),
      [getTicketConfig.rejected]: (state, payload) => ({
        ...state,
        isLoading: false,
        error: payload,
      }),
      [getTicketVenues.pending]: (state) => ({
        ...state,
        isLoading: true,
      }),
      [getTicketVenues.fulfilled]: (state, action) => {
        return {
          ...state,
          isLoading: false,
          venues: getOr(
            {
              data: [],
              total: 0,
            },
            'payload',
            action
          ),
        };
      },
      [getTicketVenues.rejected]: (state, payload) => ({
        ...state,
        isLoading: false,
        error: payload,
      }),
      [getTicketTypes.pending]: (state) => ({
        ...state,
        isLoading: true,
      }),
      [getTicketTypes.fulfilled]: (state, action) => {
        return {
          ...state,
          isLoading: false,
          ticketTypes: getOr(
            {
              data: [],
              total: 0,
            },
            'payload',
            action
          ),
        };
      },
      [getTicketTypes.rejected]: (state, payload) => ({
        ...state,
        isLoading: false,
        error: payload,
      }),
      [getTicketEvents.pending]: (state) => ({
        ...state,
        isLoading: true,
      }),
      [getTicketEvents.fulfilled]: (state, action) => {
        return {
          ...state,
          isLoading: false,
          events: getOr(
            {
              data: [],
              total: 0,
            },
            'payload',
            action
          ),
        };
      },
      [getTicketEvents.rejected]: (state, payload) => ({
        ...state,
        isLoading: false,
        error: payload,
      }),
      [getEventInsights.pending]: (state) => ({
        ...state,
        isLoading: true,
      }),
      [getEventInsights.fulfilled]: (state, action) => ({
        ...state,
        isLoading: false,
        eventInsights: getOr({ summary: {}, events: [] }, 'payload', action),
      }),
      [getEventInsights.rejected]: (state, payload) => ({
        ...state,
        isLoading: false,
        error: payload,
      }),
      [getTickets.pending]: (state) => ({
        ...state,
        isLoading: true,
      }),
      [getTickets.fulfilled]: (state, action) => {
        return {
          ...state,
          isLoading: false,
          tickets: getOr(
            {
              data: [],
              total: 0,
            },
            'payload',
            action
          ),
        };
      },
      [getTickets.rejected]: (state, payload) => ({
        ...state,
        isLoading: false,
        error: payload,
      }),
      [getOrders.pending]: (state) => ({
        ...state,
        isLoading: true,
      }),
      [getOrders.fulfilled]: (state, action) => {
        return {
          ...state,
          isLoading: false,
          orders: getOr(
            {
              data: [],
              total: 0,
            },
            'payload',
            action
          ),
        };
      },
      [getOrders.rejected]: (state, payload) => ({
        ...state,
        isLoading: false,
        error: payload,
      }),
      [getOrderItems.pending]: (state) => ({
        ...state,
        isLoading: true,
      }),
      [getOrderItems.fulfilled]: (state, action) => {
        return {
          ...state,
          isLoading: false,
          orderItems: getOr([], 'payload', action),
        };
      },
      [getOrderItems.rejected]: (state, payload) => ({
        ...state,
        isLoading: false,
        error: payload,
      }),
      [downloadTicketsCSV.fulfilled]: (state, action) => ({
        ...state,
        isLoading: false,
        csv: getOr([], 'payload.data', action).map((r) => ({
          'Event Date & Time': `${moment(`${r.startTime}Z`).format(
            'MMM Do YYYY, HH:mm'
          )} - ${moment(`${r.endTime}Z`).format('MMM Do YYYY, HH:mm')}`,
          'Event Name': r.eventName,
          'Order #': r.orderNumber,
          'Ticket #': r.ticketNumber,
          'Ticket Type': r.ticketType,
          'First Name': r.firstName,
          'Last Name': r.lastName,
          Email: r.email,
          Status:
            ['Reserved', 'Active', 'CheckedIn', 'Expired', 'Refunded'][
              r.status
            ] || '',
          'Check-In DateTime':
            r.checkInAt &&
            moment(`${r.checkInAt}Z`).format('MMM Do YYYY, HH:mm'),
        })),
      }),
      [downloadOrdersCSV.fulfilled]: (state, action) => ({
        ...state,
        isLoading: false,
        csv: getOr([], 'payload.data', action).map((r) => ({
          'Event Date & Time': `${moment(`${r.startTime}Z`).format(
            'MMM Do YYYY, HH:mm'
          )} - ${moment(`${r.endTime}Z`).format('MMM Do YYYY, HH:mm')}`,
          'Event Name': r.eventName,
          'Order #': r.orderNumber,
          'Order Date':
            r.createdAt &&
            moment(`${r.createdAt}Z`).format('MMM Do YYYY, HH:mm'),
          Amount: r.amount,
          'First Name': r.firstName,
          'Last Name': r.lastName,
          Email: r.email,
          Status: r.status === 0 ? 'Active' : r.status === 1 ? 'Pending' : '',
        })),
      }),
      [getTicketPricing.pending]: (state) => ({
        ...state,
        isLoading: true,
      }),
      [getTicketPricing.fulfilled]: (state, action) => {
        return {
          ...state,
          isLoading: false,
          pricing: getOr(emptyTicketPricingState, 'payload', action),
        };
      },
      [getTicketPricing.rejected]: (state, payload) => ({
        ...state,
        isLoading: false,
        error: payload,
      }),
      [getEventCheckInLogs.pending]: (state) => ({
        ...state,
        isLoading: true,
      }),
      [getEventCheckInLogs.fulfilled]: (state, action) => ({
        ...state,
        isLoading: false,
        eventCheckInLogs: getOr({ data: [], total: 0 }, 'payload', action),
      }),
      [getEventCheckInLogs.rejected]: (state, payload) => ({
        ...state,
        isLoading: false,
        error: payload,
      }),
      [getEventsDiscountsList.pending]: (state) => ({
        ...state,
        isLoading: true,
      }),
      [getEventsDiscountsList.fulfilled]: (state, action) => ({
        ...state,
        isLoading: false,
        discounts: getOr([], 'payload', action),
      }),
      [deleteEventsDiscounts.pending]: (state) => ({
        ...state,
        isLoading: true,
      }),
      [deleteEventsDiscounts.fulfilled]: (state) => ({
        ...state,
        isLoading: false,
      }),
      [deleteEventsDiscounts.rejected]: (state, payload) => ({
        ...state,
        isLoading: false,
        error: payload,
      }),
      [getEventMembershipPlanConfigList.pending]: (state) => ({
        ...state,
        isLoading: true,
      }),
      [getEventMembershipPlanConfigList.fulfilled]: (state, action) => ({
        ...state,
        isLoading: false,
        membershipPlans: getOr([], 'payload', action),
      }),
      [setTicketEvent.pending]: (state) => state,
      [setTicketEvent.fulfilled]: (state, action) => ({
        ...state,
        isLoading: false,
        event: getOr({}, 'payload', action),
      }),
      [setTicketEvent.rejected]: (state, payload) => ({
        ...state,
        isLoading: false,
        error: payload,
      }),
      [setCurrentTicketEvent.fulfilled]: (state, action) => ({
        ...state,
        event: getOr({}, 'payload', action),
      }),

      [bulkTicketStatus.rejected]: (state, payload) => ({
        ...state,
        isLoading: false,
        error: payload,
      }),
      [bulkTicketStatus.pending]: (state) => ({
        ...state,
        isLoading: true,
      }),
      [bulkTicketStatus.fulfilled]: (state) => {
        return {
          ...state,
          isLoading: false,
        };
      },
      [bulkEventAction.rejected]: (state, payload) => ({
        ...state,
        isLoading: false,
        error: payload,
      }),
      [bulkEventAction.pending]: (state) => ({
        ...state,
        isLoading: true,
      }),
      [bulkEventAction.fulfilled]: (state) => ({
        ...state,
        isLoading: false,
      }),
      [getSchema.rejected]: (state, payload) => ({
        ...state,
        isLoading: false,
        error: payload,
      }),
      [getSchema.pending]: (state) => ({
        ...state,
        isLoading: true,
      }),
      [getSchema.fulfilled]: (state, action) => ({
        ...state,
        isLoading: false,
        listSchema: getOr([], 'payload', action),
      }),
      [issueTickets.rejected]: (state, payload) => ({
        ...state,
        isLoading: false,
        error: payload,
      }),
      [issueTickets.pending]: (state) => ({
        ...state,
        isLoading: true,
      }),
      [issueTickets.fulfilled]: (state) => ({
        ...state,
        isLoading: false,
      }),
      [getReportEventTickets.rejected]: (state, payload) => ({
        ...state,
        isLoading: false,
        error: payload,
      }),
      [getReportEventTickets.pending]: (state) => ({
        ...state,
        isLoading: true,
      }),
      [getReportEventTickets.fulfilled]: (state, action) => ({
        ...state,
        isLoading: false,
        eventStats: getOr([], 'payload', action),
      }),
      [getTicketPricingView.pending]: (state) => ({
        ...state,
      }),
      [getTicketPricingView.fulfilled]: (state, action) => {
        return {
          ...state,
          listTicketPricing: getOr(emptyTicketPricingState, 'payload', action),
        };
      },
      [getTicketPricingView.rejected]: (state, payload) => ({
        ...state,
        error: payload,
      }),
    },
  }),
};

const selectors = {
  selectMerchantDetails: (state) => getOr({}, 'merchant', state[name]),
  selectTicketConfig: (state) => getOr({}, 'ticketConfig', state[name]),
  selectIsLoading: (state) => getOr(false, 'isLoading', state[name]),
  selectTicketVenues: (state) => getOr(false, 'venues', state[name]),
  selectTicketTypes: (state) => getOr(false, 'ticketTypes', state[name]),
  selectTicketEvents: (state) => getOr(false, 'events', state[name]),
  selectEventInsights: (state) =>
    getOr({ summary: {}, events: [] }, 'eventInsights', state[name]),
  selectTickets: (state) => getOr(false, 'tickets', state[name]),
  selectOrders: (state) => getOr(false, 'orders', state[name]),
  selectOrderItems: (state) => getOr(false, 'orderItems', state[name]),
  selectTicketPricing: (state) =>
    getOr(emptyTicketPricingState, 'pricing', state[name]),
  selectActiveTicketEvent: (state) =>
    getOr([], 'events.data', state[name])?.find((e) => e.status === 'Draft') ||
    {},
  selectEventsDiscountsList: (state) => getOr({}, 'discounts', state[name]),
  selectEventsMembershipPlanList: (state) =>
    getOr({}, 'membershipPlans', state[name]),
  selectTicketEvent: (state) => getOr(false, 'event', state[name]),
  selectCsv: (state) => getOr({}, 'csv', state[name]),
  selectListSchema: (state) => getOr(false, 'listSchema', state[name]),
  selectEventStats: (state) => getOr(false, 'eventStats', state[name]),
  selectEventCheckInLogs: (state) =>
    getOr({ data: [], total: 0 }, 'eventCheckInLogs', state[name]),
  selectListTicketPricing: (state) =>
    getOr(emptyTicketPricingState, 'listTicketPricing', state[name]),
};

export default {
  actions: {
    ...actions,
    setTicketConfig,
    getTicketConfig,
    resetTicketConfig,
    updateStatusTicketConfig,
    setDefaultTicketConfig,
    getTicketVenues,
    getTicketTypes,
    getTicketEvents,
    getEventInsights,
    getTicketPricing,
    updateTicketPricingOrder,
    getEventsDiscountsList,
    getEventMembershipPlanConfigList,
    setEventsDiscounts,
    editEventsDiscounts,
    deleteEventsDiscounts,
    createEventMembershipPlanConfigList,
    editEventMembershipPlanConfigList,
    deleteEventMembershipPlanConfigList,
    setTicketEvent,
    previewRepeatTicketEvents,
    repeatTicketEvents,
    getTickets,
    getOrders,
    downloadTicketsCSV,
    downloadOrdersCSV,
    getOrderItems,
    setCurrentTicketEvent,
    editTicket,
    resendEmail,
    deleteTicketEvent,
    getItemsByTicketing,
    bulkTicketStatus,
    bulkTicketAction,
    bulkEventAction,
    sendCustomEmail,
    getSchema,
    deleteTicketType,
    deleteTicketPricingOfferCoupon,
    issueTickets,
    calculateTicketCost,
    sellerCheckout,
    getEventTickets,
    getEventCheckInLogs,
    getReportEventTickets,
    getTicketPricingView,
    refundTicket,
  },
  selectors,
  reducer,
  name,
};
